import React, { PureComponent } from 'react';
import { IMAGES_REPO } from '../../config';

class MoreAboutUs extends PureComponent {

  render() {
    const { values: { body, photo1, photo2, photo3 }, values } = this.props;
    return (
      <div className="more-about-us">
        <div className="more-about-us__images">
          {photo3 && <img className="img" src={`${IMAGES_REPO}${photo3}`}/>}
          {photo2 && <img className="img" src={`${IMAGES_REPO}${photo2}`}/>}
          {photo1 && <img className="img" src={`${IMAGES_REPO}${photo1}`}/>}
        </div>
        <div dangerouslySetInnerHTML={{ __html: body }}/>
      </div>
    );
  }
}

MoreAboutUs.propTypes = {};
MoreAboutUs.defaultProps = {};

export default MoreAboutUs;



// WEBPACK FOOTER //
// ./src/components/more-about-us/MoreAboutUs.js